import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { LojasProps } from 'pages/compra/configuracao-pedido/types';

const defaultRequestOptions: RequestOptionsType = {
    url: '/gestao/loja',
    sort: [{ property: 'dsNomeFantasia', direction: 'ASC' }],
    columns: 'idLoja,cdLoja,dsNomeFantasia,dsRazaoSocial',
};

type UseQueryLojasModal = {
    open: boolean;
    requestOptionsLojas?: RequestOptionsType;
    valueFilter: string;
};
export function useQueryLojasModal({ open, requestOptionsLojas, valueFilter }: UseQueryLojasModal) {
    const requestListagem = useRequestListagem();
    const { page, limit, sort } = useListagemContext();
    const base = requestOptionsLojas || defaultRequestOptions;

    const requestOptions = {
        ...base,
        sort: sort?.length ? sort : base.sort,
        query: valueFilter || undefined,
        page,
        limit,
    };

    return useQuery<RequestListagem<LojasProps[]>>({
        queryKey: ['config-pedido-lojas-modal', requestOptions],
        queryFn: () => requestListagem(requestOptions).then((res) => res.data),
        enabled: open,
    });
}
